<div [ngSwitch]="quiz.quizType" appTextSize gradeLevel="{{ gradeLevel }}">
  <ng-container *ngSwitchCase="QUIZTYPE.MULTIPLECHOICE">
    <mat-list
      *ngFor="let answer of quiz.options; let index = index"
      class="option-row"
    >
      <mat-list-item>
        <div class="answer-multi">
          <mat-checkbox [checked]="answer.correct === 'true'" disabled>
            &nbsp; &nbsp;
            {{ ordinal(answer.position) }}.&nbsp;{{ answer.answer }}
          </mat-checkbox>
        </div>
        <ng-container *ngIf="answer.fileLocation">
          <div class="image-preview">
            <img [src]="answer.fileLocation" alt="Image Preview" />
          </div>
        </ng-container>
      </mat-list-item>
    </mat-list>
  </ng-container>
  <ng-container *ngSwitchCase="QUIZTYPE.BOOLEANCHOICE">
    <div class="answer-multi">
      <mat-checkbox [checked]="quiz.trueOrFalse === true" disabled
        >True &nbsp;</mat-checkbox
      >
      <br /><br />
      <mat-checkbox [checked]="quiz.trueOrFalse === false" disabled
        >False &nbsp;</mat-checkbox
      >
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="QUIZTYPE.FREEANSWER">
    <div class="answer-free">
      <label>(Freeform answer)</label>
      <div class="option-row">
        <div class="answer-free--item">
          <p [class.answer]="isTeacher">{{ quiz.text }}</p>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngSwitchDefault>
    <p>The Assessment cannot be displayed</p>
  </ng-container>
</div>
